import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { ContentDiv, FlexWrapper, NavDiv } from './Legal.styles';
import { ApButtonTab } from '@alixpartners/ui-components';
import LegalRateBenchmarks from './LegalRateBenchmarks/LegalRateBenchmarks';
import TopLegalVendors from './TopLegalVendors/TopLegalVendors';

const Legal = ({ setCurrentContent }) => {
	const INITIAL_SUBNAV_CONFIG = [
		{
			id: 0,
			name: 'top-legal-vendors',
			label: 'Top Legal Vendors',
			component: TopLegalVendors,
		},
		{
			id: 1,
			name: 'legal-rate-benchmarks',
			label: 'Legal Rate Benchmarks',
			component: LegalRateBenchmarks,
		},
	];
	const [activeTab, setActiveTab] = useState(INITIAL_SUBNAV_CONFIG[0].id);

	const subNavHandler = useCallback(id => {
		setActiveTab(id);
	}, []);

	return (
		<>
			<FlexWrapper>
				<NavDiv>
					{INITIAL_SUBNAV_CONFIG.map(({ id, name, label }) => (
						<ApButtonTab
							key={id}
							name={name}
							isSelected={id === activeTab}
							onClick={() => {
								subNavHandler(id);
							}}
							small
						>
							{label}
						</ApButtonTab>
					))}
				</NavDiv>
			</FlexWrapper>

			<ContentDiv>
				{INITIAL_SUBNAV_CONFIG.map(
					({ id, label, component: Component }) =>
						id === activeTab && (
							<Component
								key={id}
								setCurrentContent={setCurrentContent}
								label={label}
							/>
						)
				)}
			</ContentDiv>
		</>
	);
};

Legal.propTypes = {
	setCurrentContent: PropTypes.func.isRequired,
};

export default Legal;
